<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle id="inner_oval" cx="9" cy="9" r="6" />
</svg>